import {useLocation} from 'react-router-dom';

const useQuery = () => {
  const urlSearchParamsObject = new URLSearchParams(useLocation().search);

  const allParams = {};

  for (let [key, value] of urlSearchParamsObject.entries()) {
    allParams[key] = value;
  }

  return {
    getQueryParam: urlSearchParamsObject.get.bind(urlSearchParamsObject),
    allParams,
    urlSearchParamsObject,
  };
};

export default useQuery;
